import Axios from 'axios'
import { message } from 'antd'

export async function getInstagramInfo(nickname) {
  try{
      let userInfoSource = await Axios.get(`https://www.instagram.com/${nickname}/`)

  // userInfoSource.data contains the HTML from Axios
  let jsonObject = userInfoSource.data.match(/<script type="text\/javascript">window\._sharedData = (.*)<\/script>/)[1].slice(0, -1)

  return JSON.parse(jsonObject)
  }
  catch(e){
    message.error(`Can't load photos for Instagram account ${nickname}`)
    return null
  }
}

export async function getInstagramFeed(nickname) {
  let response = await getInstagramInfo(nickname)
  if (!response) return

  let photosEdges = response.entry_data.ProfilePage && response.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges
  let photos = []

  photosEdges && photosEdges.forEach(item => {
    try {
      var titleEdge = item.node.edge_media_to_caption.edges[0]
      var postUrl = `https://www.instagram.com/p/${item.node.shortcode}/`
      photos.push({
        id: item.node.shortcode,
        title: titleEdge && titleEdge.node.text,
        image_url: item.node.thumbnail_resources[2].src,
        post_url: postUrl
      })
    } catch(e) {}
  });

  return photos
}


// WEBPACK FOOTER //
// ./src/services/instagram.js